import { render, staticRenderFns } from "./editMasterProvider.vue?vue&type=template&id=0a58210c&"
import script from "./editMasterProvider.vue?vue&type=script&lang=js&"
export * from "./editMasterProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports